//@ts-nocheck
// settings for field cards effect

export const cardStacking = () => {
  const cards = document.querySelectorAll('.js-effect-card');

  const STICKY_LIMIT = () => {
    if (window.innerWidth > 767) {
      if (window.innerHeight < 767) {
        return window.innerHeight - cards[1].offsetHeight - 100;
      } else {
        return 60;
      }
    } else {
      return window.innerHeight - cards[1].offsetHeight - 64;
    }
  };

  // cards.forEach((card) => {
  //   card.style.height = `${cards[1].offsetHeight + 20}px`;
  // });

  function animateStackCards() {
    var top = this.element.getBoundingClientRect().top;

    for (let i = 0; i < this.items.length; i++) {
      const card = this.items[i];
      const rect = card.getBoundingClientRect();

      // const rawScrolling = rect.top - top - i * card.offsetHeight;

      // prevent scaling before sticky point
      // const scrolling = Math.max(rawScrolling, 0);

      // Translation clamps at sticky limit
      const translateY = i * 20;

      const isLastCard = i === this.items.length - 1;

      let scale;

      if (isLastCard) {
        scale = 1;
      } else {
        const rawScrolling = rect.top - top - i * card.offsetHeight;
        const scrolling = Math.max(rawScrolling, 0);

        scale = Math.max(
          (card.offsetHeight - scrolling * 0.05) / card.offsetHeight,
          0.9
        );
      }
      card.style.transform = `
      translateY(${translateY}px)
      scale(${scale})
    `;
      card.style.top = `${STICKY_LIMIT()}px`;
    }

    this.scrolling = false;
  }

  function stackCardsScrolling() {
    if (this.scrolling) return;
    this.scrolling = true;
    window.requestAnimationFrame(animateStackCards.bind(this));
  }

  function stackCardsInitEvent(element) {
    element.scrollingListener = stackCardsScrolling.bind(element);
    window.addEventListener('scroll', element.scrollingListener);
  }

  function stackCardsCallback(entries) {
    if (entries[0].isIntersecting) {
      if (this.scrollingListener) return;
      stackCardsInitEvent(this);
    } else {
      if (!this.scrollingListener) return;
      window.removeEventListener('scroll', this.scrollingListener);
      this.scrollingListener = false;
    }
  }

  function initStackCardsEffect(element) {
    // use Intersection Observer to trigger animation
    var observer = new IntersectionObserver(stackCardsCallback.bind(element), {
      threshold: [0, 1],
    });
    observer.observe(element.element);
  }

  var StackCards = function (element) {
    this.element = element;
    this.items = this.element.getElementsByClassName('js-effect-card');
    this.scrollingFn = false;
    this.scrolling = false;
    initStackCardsEffect(this);
  };

  var stackCards = document.getElementsByClassName('js-panel-section'),
    intersectionObserverSupported =
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype;

  if (stackCards.length > 0 && intersectionObserverSupported) {
    for (var i = 0; i < stackCards.length; i++) {
      new StackCards(stackCards[i]);
    }
  }
};

// export const resizeCards = () => {
// const cards = document.querySelectorAll('.js-effect-card');
// if (cards.length === 0) return;
// if (window.innerWidth <= 767) {
//   for (let i = 0; i < cards.length; i++) {
//     if (i === cards.length - 1) {
//       // last card
//       cards[i].style.height = `${cards[1].offsetHeight - 180}px`;
//     } else {
//       cards[i].style.height = `${cards[1].offsetHeight + 20}px`;
//     }
//   }
// } else {
//   cards.forEach((card) => {
//     card.style.height = `${window.innerHeight - 140}px`;
//   });
// }
// };
